<template class="programEfficiency">
  <div class="card card-visitors">
    <div class="card-header card-chart-mini">
      <div class="d-flex flex-row align-items-center">
        <img
          src="../../src/assets/icons/file-medical-alt.svg"
          class="ico-18 mr-2 "
        />
        <span v-if="title">{{ title }}</span>
      </div>
    </div>
    <div class="card-body py-0">
      <div class="d-column flex-row">
        <div class="loading d-flex">
          <div v-if="loading" class="c-loader m-2"></div>
          <h6
            v-if="!loading && isAllMetricsZero()"
            class="p-3"
            v-text="$ml.get('metricsDoesNotHaveEnoughDataYet')"
          >
            Ainda não existem dados suficientes para cálculo das métricas
          </h6>
        </div>
        <div>
          <div v-if="!isAllMetricsZero()">
            <div
              v-for="(item, index) in arrayOfAverageMetrics"
              :key="index"
              class="h-profile d-flex align-items-center py-3"
            > 
              <div class="d-flex align-items-center w-100">
                <div class="align-self-center w-100" v-if="arrayOfAverageMetrics[index][1] !== 0" >

                  <div class="row justify-content-between mb-2">
                    <h3 v-text=" `${arrayOfAverageMetrics[index][1]}` + ' ' + `${ arrayOfAverageMetrics[index][1] > 1 ? $ml.get('days') : $ml.get('day') }` " ></h3>
                    <img
                      v-b-tooltip.hover
                      :title="$ml.get(getTooltip(arrayOfAverageMetrics[index][0]))"
                      src="../../src/assets/icons/interrogation.png"
                      class="ico-18 m-0 mt-1"
                    />
                  </div>
                  <span v-text="$ml.get(`${arrayOfAverageMetrics[index][0]}`)" ></span>
                  <div v-if="verifyNeedLblError(index) && userIsCompany">
                    <label
                      class="txtError mt-2 mb-0"
                      v-text="`${$ml.with('interationType', $ml.get(getInterationType(index)) ) .get('interationIdealTime')}` + getInterationDays(index) ">
                    </label>
                  </div>
                </div>

                <div class="align-self-center" v-if="arrayOfAverageMetrics[index][1] === 0" >
                  <div>
                    <span v-text="$ml.get('metricDoesNotHaveEnoughDataYet')"
                      >Não existem dados suficientes para cálculo desta
                      métrica</span
                    >
                  </div>
                </div> 
              </div>
            </div>
            <label
              class="mt-3 text-primary"
              style="font-size: 11px;"
              v-if="needDangerWarning && userIsCompany"
              v-text="'*' + $ml.get('longPeriodsImpactSpecialists')"
            />
            <label
              class="mt-1 text-grey"
              style="font-size: 11px;"
              v-if="needDangerWarning && userIsCompany"
              v-text="'*' + $ml.get('basedLast90Day')"
            ></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProgramService from "../services/program.service";
export default {
  name: "ProgramEfficiency",

  props: {
    title: {
      required: true,
      default: "",
    },
  },

  components: {},

  data() {
    return {
      loading: true,
      needDangerWarning: false,
      arrayOfAverageMetrics: [],
      arrayOfProgramMetrics: [],
    };
  },

  computed: {
    userIsCompany() {
      return this.$store.getters["getUserType"] === "company";
    },
  },

  mounted() {
    const id = this.$route.fullPath.split("?")[1];
    this.getMetrics(id);
  },

  methods: {
    getTooltip(avg) {
      switch (avg) {
        case "average_time_to_first_response":
          return "avgTimeToFirstResponse";
        case "average_time_to_resolution":
          return "avgTimeToResolution";
        case "average_time_to_bounty":
          return "avgTimeToBunty";
      }
    },

    getInterationType(index) {
      const type = this.arrayOfAverageMetrics[index][0];
      switch (type) {
        case "average_time_to_first_response":
          return "timeToFirstResponse";
        case "average_time_to_resolution":
          return "timeToResolution";
        case "average_time_to_bounty":
          return "avgTimeToBunty";
      }

      return type;
    },

    getInterationDays(index) {
      const time = this.arrayOfProgramMetrics[index][1];
      if (time > 1) {
        return `${time} ${this.$ml.get("days")}`;
      }
      return `${time} ${this.$ml.get("day")}`;
    },

    isAllMetricsZero() {
      let possibleZero = true;
      for (let i in this.arrayOfAverageMetrics) {
        if (this.arrayOfAverageMetrics[i][1] !== 0) {
          possibleZero = false;
        }
      }
      return possibleZero;
    },

    verifyIfNeedDangerWarning() {
 
      for (let i in this.arrayOfAverageMetrics) {
        if (
          this.arrayOfAverageMetrics[i][1] > this.arrayOfProgramMetrics[i][1]
        ) {
          this.needDangerWarning = true;
        }
      }
    },

    verifyNeedLblError(index) {
      return (
        this.arrayOfAverageMetrics[index][1] >
        this.arrayOfProgramMetrics[index][1]
      );
    },

    getMetrics(id) {
      this.loading = true;

      ProgramService.getProgramMetrics(id).then(
        ({ data }) => {
 
          let arrayOfMetrics = Object.entries(data);
          this.arrayOfAverageMetrics = arrayOfMetrics.filter((item) =>
            item[0].includes("average")
          );

          this.arrayOfProgramMetrics = arrayOfMetrics.filter((item) =>
            item[0].includes("program")
          );
          
          this.loading = false;
          this.verifyIfNeedDangerWarning();
        },
        () => {
          this.loading = false;
        }
      );
    },
  },
};
</script>

